import { render } from "./App2.vue?vue&type=template&id=006e2c90&scoped=true&ts=true"
import script from "./App2.vue?vue&type=script&lang=ts"
export * from "./App2.vue?vue&type=script&lang=ts"

import "./App2.vue?vue&type=style&index=0&id=006e2c90&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006e2c90"]])

export default __exports__